@if(contentLoading() || !platform.isPlatformBrowser()){
<app-loading-spinner></app-loading-spinner>
}
<router-outlet></router-outlet>
<p-toast
  [life]="7000"
  position="top-right"
/>